import React, { Component } from 'react'
import { Card } from 'react-bootstrap';
import MainMenu from '../../components/menu/MainMenu';
import { DebitProfile } from './debitProfile';


export default class MerchantCategory extends Component {

  render() {
    const {role} = this.props;
    return (
      <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
        <Card.Body className="p-0 bg-grey">
          <MainMenu mainMenu={"account"} subMenu={"profile"} role={role}/>
            <DebitProfile {...this.props} />
        </Card.Body>
      </Card>
    )
  }
}